// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__+iehd","Category":"Home_Category__+ffw5"};